import React from 'react';
import Icon from '../../../components/AppIcon';

const InsightCard = ({ title, icon, iconColor, items }) => {
  return (
    <div className="bg-card rounded-xl p-5 sm:p-6 border border-border">
      <div className="flex items-center gap-2.5 sm:gap-3 mb-4">
        <div className="bg-muted rounded-full p-2.5 sm:p-2">
          <Icon name={icon} size={20} color={iconColor} />
        </div>
        <h3 className="text-base sm:text-lg font-semibold text-foreground">{title}</h3>
      </div>
      <ul className="space-y-3">
        {items?.map((item, index) => (
          <li key={index} className="flex items-start gap-2.5 sm:gap-2">
            <Icon name="ChevronRight" size={18} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
            <span className="text-sm sm:text-sm text-foreground leading-relaxed">{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default InsightCard;